<h2 mat-dialog-title>Busqueda Cliente</h2>
<mat-dialog-content class="mat-typography">
  <div class="row">
    <div class="col s12 m12 l12" style="text-align: center">
      <p style="color: red; font-size: 16px; font-weight: bold">
        Por favor seleccione el cliente que desea ingresar
      </p>
    </div>
  </div>

  <cdk-virtual-scroll-viewport itemSize="25" minBufferPx="200" maxBufferPx="400" class="example-viewport">

  <mat-nav-list>
    <h3 mat-subheader>LISTADO DE CLIENTES</h3>
    <mat-list-item
      *cdkVirtualFor="let cliente of empresaSucursal"
      (click)="clienteSeleccionado(cliente)"
    >
      <mat-icon mat-list-icon>person</mat-icon>
      <h3 class="titulo-item" mat-line>
        <span style="color: grey; font-weight: bold">Razón Social:</span>
        {{ cliente.nit }} -- {{ cliente.razonSocial }}
        <span style="color: grey; font-weight: bold">Ciudad:</span>
        {{ cliente.ciudad || "" }}
        <span style="color: grey; font-weight: bold">Direccion:</span>
        {{ cliente.direccion || "" }}
      </h3>
      <mat-divider></mat-divider>
    </mat-list-item>
  </mat-nav-list>

</cdk-virtual-scroll-viewport>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="clienteSeleccionado('')">
    Cerrar
  </button>
</mat-dialog-actions>
